/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import t from 'tcomb-validation';
import { convertObjectToValueArray } from 'schemas/utils';
import { PaymentMethodType } from 'config/constants';

const PaymentMethodTypes = t.enums.of(convertObjectToValueArray(PaymentMethodType));

export default PaymentMethodTypes;
